<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
							<!--SID1020 Body Part-->
							<template>
								<el-container class="SID1020__noticeAdmin">
									<div class="SID1020__Container">
										<!-- Breadcrumb section -->
										<el-breadcrumb separator-class="el-icon-arrow-right customStyle">
											<el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
											<el-breadcrumb-item :to="{ path: '1019-001' }"
												> トピックス作成(初期状態)</el-breadcrumb-item
											>
											<el-breadcrumb-item :to="{ path: '' }"
												>トピックス作成結果</el-breadcrumb-item
											>
										</el-breadcrumb>
										<!-- Breadcrumb section Ended -->
                                        <el-container class="infoSucess">
                                            <div>
                                             <span class="">トピックス作成は正常に完了しました。</span>
                                             <span class="" >トピックスタイトル： <span class="textalign_css">{{title}}</span>  <span class="textalign_css">{{date}}</span></span>
                                             <span class="textalign_css1">作成したトピックスをメール送信する場合には、「メール送信」ボタンを押下してください。</span>
                                        </div>
                                        </el-container>
                                        <!-- For button -->
                                        <div class="BottomButtonDivTable">
														<el-button class="setMarginTop" type="primary"  style="" plain @click="tableClick_1" 	>メール送信</el-button>
                                                        <el-button class="setMarginTop" type="primary"  style="" plain @click="tableClick_2" 	>別トピックス作成</el-button>
														
										</div>
                                        <!-- For button Ended-->
									</div>
								</el-container>
							</template>
							<!--SID1020 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>

			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import router from '../../router';
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
		return {
			date:'',
			title:'',
			medium:'',
			topic:''
		};
	},
	methods: {
		tableClick_1(){
			this.$LogButtonEvent("1020","SendEmail");
			this.$LogMethodIN("1020","tableClick1");
			// 2024/10/07  #18753  START
			//router.push({name:"1002",params: {fromTopPage:'2',title: this.$route.params.title,medium:this.medium,topic:this.topic}});
			router.push({name:"1002",params: {fromTopPage:'2',title: this.$route.params.title,medium:this.medium == '雑誌'? '雑誌/WEB':this.medium,topic:this.topic}});
			// 2024/10/07  #18753  END
		this.$LogMethodOut("1020","tableClick1");
		},
		tableClick_2(){
this.$LogButtonEvent("1020","CreateTopic");
this.$LogMethodIN("1020","tableClick2");
			router.push({name:'1019-001'})
			this.$LogMethodOut("1020","tableClick2");
		}
	},
	mounted(){
		
		var original_date = this.$route.params.date;
		var split_datebyslash = original_date.split('/');
		var finial_date = split_datebyslash[0] +'年' +split_datebyslash[1] +'月'+split_datebyslash[2] +'日'
		this.date = finial_date;
		this.title = this.$route.params.title;
		this.medium = this.$route.params.medium;
		this.topic = this.$route.params.topic_id
		
	},
	computed: {},
	beforeCreate(){
		//Common.Session.CheckSessionExists_IfExpired_GoToLogout();
	},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1020.css";
</style>